import GaugeWidget from './GaugeWidget'
import TextWidget from './TextWidget'
import ChartWidget from './ChartWidget'
import TableWidget from './TableWidget'
import NetworkMapWidget from './NetworkMapWidget'
import ValueWidget from './ValueWidget'
import SliderWidget from './SliderWidget'
import TriggerWidget from './TriggerWidget'
import StatusSwitcherWidget from './StatusSwitcherWidget'
import MapWidget from './MapWidget'



const WidgetComponents = {
    GaugeWidget,
    TextWidget,
    ChartWidget,
    TableWidget,
    NetworkMapWidget,
    ValueWidget,
    SliderWidget,
    TriggerWidget,
    StatusSwitcherWidget,
    MapWidget,

}

export default WidgetComponents;